import { startCase } from 'lodash';

import Avatar from 'components/Avatar';
import Typography from 'components/Typography';

import { getAdvocateDisplayName } from 'utils/name';
import {
  PARTICIPANT_NAME_SYSTEM_ACTUAL,
  PARTICIPANT_NAME_SYSTEM_FRIENDLY,
  PARTICIPANT_PREFIX,
} from 'constants/twilio';

import { StyledAuthorHeader } from './styles';
import { useConversation } from 'hooks/conversation';
import { htmlId } from 'utils/html';

export const BaseAuthorHeader = ({
  displayName,
  active = true,
}: {
  displayName: string;
  active?: boolean;
}) => (
  <StyledAuthorHeader id={htmlId('message-author')}>
    <Avatar participantName={displayName} key={displayName} showPresence={active} size='2rem' />
    <Typography as='span' color='strong' emphasis='strong' variant='body' size='md'>
      {startCase(displayName)}
    </Typography>
  </StyledAuthorHeader>
);

export const AuthorHeader = ({ author = '' }: { author?: string }) => {
  const { conversationState } = useConversation();

  if (author.includes(PARTICIPANT_PREFIX.ADVOCATE)) {
    const advocateDisplayName = getAdvocateDisplayName(author);
    const participantActive = !!conversationState.participants.advocates.find(
      (adv) => adv.identity === author,
    );

    return <BaseAuthorHeader active={participantActive} displayName={advocateDisplayName || ''} />;
  }
  if (author === PARTICIPANT_NAME_SYSTEM_ACTUAL) {
    return <BaseAuthorHeader displayName={PARTICIPANT_NAME_SYSTEM_FRIENDLY} />;
  } else {
    // Default style: left orientation message with no avatar.
    return null;
  }
};
